

















































































































import Vue from 'vue';
import VideoModel from '@/dex-shared/models/VideoModel';
import { authenticate, getVideoInfo } from '@/helpers/kaltura';
import Hls from 'hls.js';

export default Vue.extend({
  props: {
    video: {
      type: Object,
      required: true,
      validator: function(value: VideoModel) {
        return value.providerType === 'KALTURA';
      },
    },
    uniqueId: {
      type: String,
      required: true,
    },
  },

  data: function() {
    return {
      PARTNER_ID: 1612851,
      UICONF_ID: 21336162,
      activeKalturaEntryId: '',
      playerMode: 'loading' as 'loading' | 'kaltura' | 'hls' | 'error',
      hlsInstance: null as any,
    };
  },

  computed: {
    kalturaIframeSrc(): string {
      if (!this.activeKalturaEntryId) return '';

      const p = this.PARTNER_ID;
      const base = `https://cdnapisec.kaltura.com/p/${p}/sp/${p}00/embedIframeJs/uiconf_id/${this.UICONF_ID}/partner_id/${p}`;
      const q = new URLSearchParams({
        iframeembed: 'true',
        playerId: this.uniqueId,
        entry_id: this.activeKalturaEntryId,
      });

      return `${base}?${q.toString()}`;
    },
  },

  watch: {
    'video.providerId': {
      handler() {
        this.resolvePlayer();
      },
    },
    uniqueId() {
      this.resolvePlayer();
    },
  },

  mounted() {
    this.resolvePlayer();
  },

  beforeDestroy() {
    this.destroyHls();
  },

  methods: {
    resolvedEntryId(): string {
      const pid = String(this.video.providerId || '').trim();
      if (!pid) return '';

      if (/^https?:\/\//i.test(pid)) {
        const m = pid.match(/([^/]+)\.m3u8(?:\?|#|$)/i);
        if (m) return m[1].split('?')[0];
      }
      return pid;
    },

    streamFallbackUrl(): string {
      const pid = String(this.video.providerId || '').trim();
      if (!pid) return '';

      if (/^https?:\/\//i.test(pid) && /\.m3u8/i.test(pid)) {
        return pid.split('#')[0];
      }

      const id = this.resolvedEntryId();
      if (!id) return '';

      return `https://videos-stream-pg.b-cdn.net/${id}/${id}.m3u8`;
    },

    async resolvePlayer() {
      this.activeKalturaEntryId = '';
      this.destroyHls();
      this.playerMode = 'loading';

      const entryId = this.resolvedEntryId();
      if (!entryId) {
        this.playerMode = 'error';
        return;
      }

      try {
        await authenticate();
        await getVideoInfo(entryId);
        this.activeKalturaEntryId = entryId;
        this.playerMode = 'kaltura';
      } catch {
        const url = this.streamFallbackUrl();
        if (!url) {
          this.playerMode = 'error';
          return;
        }
        this.playerMode = 'hls';
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.setupHls(url);
          });
        });
      }
    },

    destroyHls() {
      if (this.hlsInstance) {
        this.hlsInstance.destroy();
        this.hlsInstance = null;
      }
      const video = this.$refs.hlsVideo as HTMLVideoElement | undefined;
      if (video) {
        video.removeAttribute('src');
        video.load();
      }
    },

    setupHls(url: string) {
      const video = this.$refs.hlsVideo as HTMLVideoElement | undefined;
      if (!video) {
        this.playerMode = 'error';
        return;
      }

      const fail = () => {
        this.destroyHls();
        this.playerMode = 'error';
      };

      try {
        if (Hls.isSupported()) {
          const hls = new Hls();
          this.hlsInstance = hls;
          hls.on(Hls.Events.ERROR, (_: string, data: any) => {
            if (data && data.fatal) fail();
          });
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.muted = true;
            video.play().catch(() => {});
          });
          hls.loadSource(url);
          hls.attachMedia(video);
          video.muted = true;
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.muted = true;
          video.src = url;
          video.addEventListener('error', fail, { once: true });
          video.addEventListener(
            'loadedmetadata',
            () => {
              video.play().catch(() => {});
            },
            { once: true },
          );
        } else {
          fail();
        }
      } catch {
        fail();
      }
    },
  },
});
